module.exports = __webpack_public_path__ + "static/media/question-square.9c4890a2.svg";